import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import { Component } from "react"
import { Link } from "react-router-dom"


export default class MasonryCard extends Component {

  state = {
    width:             null,
    height:            null,
    additionalClasses: ""
  }

  onLoad = ( { target: img } ) => {
    const width = img.offsetWidth
    const height = img.offsetHeight

    const isSquare = width === height
    const isLandscape = width > height
    const isPortrait = height > width

    const additionalClasses = []
    isSquare && additionalClasses.push( "square" )
    isLandscape && additionalClasses.push( "landscape" )
    isPortrait && additionalClasses.push( "portrait" )

    this.setState( {
      additionalClasses: additionalClasses.join( " " ),
      height,
      width
    } )

    this.props.onReady && this.props.onReady()
  }

  render() {
    const { additionalClasses } = this.state
    const { category, fallback, title = true } = this.props
    const parents = category.getParents()
    return <Link
      title={category.title}
      to={`/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}`}
      className={`MasonryCard grid-item ${additionalClasses} category-${category.desc.des} category-id-${category.map_id}`}>
      <div className="img-overlay bg-dark-green" style={{ backgroundImage: `url("${category.img_src}")` }}/>
      <ImageWithFallback onLoad={this.onLoad} fallback={fallback} src={category.img_src}/>
      {title && <div className={"pa3"}>{category.desc.short_des}</div>}
    </Link>
  }
}



// WEBPACK FOOTER //
// ./src/theme/fiebiger/plugin/CategoryShortcuts/MasonryCard.js